import React from "react";
import { Modal } from "react-bootstrap";
import { getLocalStorageVariables, handleTokenExpiry, isEmptyVariable } from "../Global/commonFunctions";
import { AlertDialogSpan,DialogProceedButton} from "../Global/globalStyles.style";
import * as Constants from "../Global/constants";
import ReactSelectDropdown from "../DropdownMenus/ReactSelectDropdownWithSearch";

let userDetails = {};

class AlertWithDropdownDialog extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			newUserId:"",
            newUserPlaceholder:"Select User",
            errorMsg:"",
			formErrors: {},
		};
		userDetails = getLocalStorageVariables();
	}

	componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showAlertDialog){
            this.setState({
                newUserId:"",
				newUserPlaceholder:"Select User",
				errorMsg:"",
				formErrors: {},
            },() => {
				this.reopenTaskMasterData();
			})
        }
    }

	usersDropdownClick = (item) => {
        this.setState({
            newUserId:item.userId,
            newUserPlaceholder:item.fullName,
            errorMsg:""
        })
    }

	handleProceedButtonClick = () => {
		let isError = false;
		let errorMessage = "";

		if(isEmptyVariable(this.state.newUserId)){
			isError = true;
            errorMessage = "Please select the new user"
		}

		if (isError) {
			this.setState({
				errorMsg:errorMessage
			});

			setTimeout(
				function () {
					this.setState({
						errorMsg: "",
					});
				}.bind(this),
				Constants.WRNG_MSG_TIMEOUT
			);
		} else {
			this.props.proceedBtnClick(this.state.newUserId, true);
		}
	};

	reopenTaskMasterData = () => {
		fetch(Constants.ReopenTaskMasterData,
		{
			method: "POST",
			mode:'cors',
			body: new URLSearchParams({
				email:userDetails.email,
				accessToken:userDetails.accessToken,
				assignmentId:this.props.assignmentId,
				assignmentTaskId:this.props.assignmentTaskId,
			})
		}).then(res=>{
			return res.json();
		}).then(res=>{
			if(handleTokenExpiry(res.responseCode)) return;
			if(res.responseCode === Constants.CODE_SUCCESS){
				let reOpenToUserList = res.data.reOpenToUserList;
				this.setState({
					showLoader: false,
					reOpenToUserList:reOpenToUserList
				})
			}else{
				this.setState({
					showLoader: false,
					showAlertDialogInfo:true,
					alertDialogMessageInfo:res.responseMessage
				})            
			}
		})
	}

	render() {
		return (
			<Modal show={this.props.showAlertDialog} backdrop="static">
				<Modal.Body>
					<div class="dialog-layout">
						<button onClick={this.props.handleAlertDialogClose}>
							<span className="material-icons">close</span>
						</button>
						<AlertDialogSpan 
                            themeSettings={this.props.themeSettings}
                            className="material-icons">error_outline</AlertDialogSpan>
						{
							// !this.props.type === Constants.ALERT_TYPE_ALERT &&
							!isEmptyVariable(this.props.alertDialogHeading) && <h5>{this.props.alertDialogHeading}</h5>
						}
						<p style={{ marginBottom: 15 }}>{this.props.alertDialogMessage}</p>
						<div className="newuser-dd-layout">
							<ReactSelectDropdown
								handleReactSelectClose={this.usersDropdownClick}
								selectDropdownArr={this.state.reOpenToUserList}
								label={"fullName"}
								value={"userId"}
								placeholder={this.state.newUserPlaceholder}
							/>
						</div>
						{
                            this.state.errorMsg &&
                            <span className="cm-error dialog-error">{this.state.errorMsg}</span>
                        }
						<div class="dialog-btn-layout">
							<a class="alert-cancel" href="javascript:void(0);" onClick={this.props.handleAlertDialogClose}>
								Cancel
							</a>

							<DialogProceedButton
								themeSettings={this.props.themeSettings}
								class="alert-proceed"
								href="javascript:void(0);"
								onClick = {this.handleProceedButtonClick}
								style={{
									marginLeft:(this.props.type === Constants.ALERT_TYPE_ALERT)?"0px":"10px"
								}}
							>
								{this.props.showLoader ? <div class="loader-btn mt-2"></div> : this.props.proceedBtnLabel}
							</DialogProceedButton>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		);
	}
}

export default AlertWithDropdownDialog;
